<p class="ba-message-actions">
    @for (action of nachrichtActions; track action) {
        @switch (action) {
            @case (nachrichtAction.REPLY) {
                <a
                        href="#"
                        class="ba-link-icon ba-icon-reply"
                        (click)="clickedButton(action, $event)"
                        [id]="'reply-btn' + nachrichtId"
                >{{ 'message-actions.reply' | i18next }}</a>
            }
            @case (nachrichtAction.EDIT) {
                <a
                        href="#"
                        class="ba-link-icon ba-icon-edit"
                        (click)="clickedButton(action, $event)"
                        [id]="'edit-btn' + nachrichtId"
                >{{ 'message-actions.edit-draft' | i18next }}</a>
            }
            @case (nachrichtAction.RESTORE) {
                <a
                        href="#"
                        class="ba-link-icon ba-icon-repeat"
                        (click)="clickedButton(action, $event)"
                        [id]="'restore-btn' + nachrichtId"
                >{{ 'message-actions.restore-message' | i18next }}</a>
            }
            @case (nachrichtAction.DOWNLOAD) {
                <a
                        href="#"
                        class="ba-link-download"
                        [title]="downloadTitle()"
                        (click)="clickedButton(action, $event)"
                        [id]="'download-btn' + nachrichtId"
                >{{ 'message-actions.download' | i18next }}</a>
            }
            @case (nachrichtAction.DELETE) {
                <a
                        href="#"
                        class="ba-link-icon ba-icon-trash"
                        (click)="clickedButton(action, $event)"
                        [id]="'delete-btn' + nachrichtId"
                >{{
                        (nachrichtFolder === OrdnerEnum.ENTWURF
                            ? 'message-actions.delete-draft'
                            : 'message-actions.delete-message') | i18next
                    }}</a>
            }
            @case (nachrichtAction.DELETE_IRREVOCABLE) {
                <a
                        href="#"
                        class="ba-link-icon ba-icon-trash"
                        (click)="clickedButton(action, $event)"
                        [id]="'delete-irreversible-btn' + nachrichtId"
                >{{ 'message-actions.delete-message-irrevocable' | i18next }}</a>
            }
        }
    }
</p>